const adjectives = [
  "aback",
  "abiding",
  "ablaze",
  "able",
  "abounding",
  "absorbed",
  "abundant",
  "accessible",
  "accurate",
  "acoustic",
  "adaptable",
  "adorable",
  "adventurous",
  "aerial",
  "agreeable",
  "alert",
  "alive",
  "alluring",
  "alpine",
  "amazing",
  "ambitious",
  "amused",
  "amusing",
  "ancient",
  "animated",
  "aquatic",
  "aromatic",
  "artistic",
  "aspiring",
  "astonishing",
  "atomic",
  "attractive",
  "available",
  "awake",
  "awesome",
  "azure",
  "balanced",
  "beautiful",
  "befitting",
  "beneficial",
  "big",
  "billowy",
  "bold",
  "boundless",
  "brainy",
  "brave",
  "breezy",
  "brief",
  "bright",
  "broad",
  "bubbly",
  "bustling",
  "calm",
  "capable",
  "carefree",
  "careful",
  "caring",
  "casual",
  "celestial",
  "certain",
  "changeable",
  "charming",
  "cheerful",
  "circular",
  "classic",
  "classy",
  "clean",
  "clear",
  "clever",
  "climbing",
  "coherent",
  "colorful",
  "colossal",
  "comfortable",
  "complete",
  "concise",
  "concrete",
  "conscious",
  "cool",
  "cooperative",
  "cosmic",
  "courageous",
  "creative",
  "crimson",
  "cubic",
  "cuddly",
  "curious",
  "cyan",
  "daily",
  "dandy",
  "dapper",
  "daring",
  "dashing",
  "dazzling",
  "dear",
  "debonair",
  "decisive",
  "dedicated",
  "deep",
  "defiant",
  "delicate",
  "delicious",
  "delightful",
  "descriptive",
  "determined",
  "different",
  "diligent",
  "dynamic",
  "eager",
  "early",
  "earthy",
  "eastern",
  "easy",
  "efficient",
  "elated",
  "electric",
  "elegant",
  "elite",
  "eminent",
  "enchanted",
  "enchanting",
  "encouraging",
  "energetic",
  "enormous",
  "entertaining",
  "enthusiastic",
  "ethereal",
  "even",
  "everlasting",
  "excellent",
  "excited",
  "exciting",
  "exuberant",
  "fabulous",
  "faint",
  "fair",
  "faithful",
  "familiar",
  "famous",
  "fancy",
  "fantastic",
  "fast",
  "fearless",
  "festive",
  "fierce",
  "fine",
  "first",
  "flawless",
  "flickering",
  "flourishing",
  "flowery",
  "fluffy",
  "flying",
  "foggy",
  "fortunate",
  "fragrant",
  "free",
  "freezing",
  "fresh",
  "friendly",
  "frosted",
  "full",
  "functional",
  "funny",
  "futuristic",
  "gainful",
  "gentle",
  "giant",
  "gifted",
  "gilded",
  "glamorous",
  "gleaming",
  "glistening",
  "glittery",
  "global",
  "glorious",
  "glossy",
  "glowing",
  "golden",
  "good",
  "gorgeous",
  "graceful",
  "grand",
  "grateful",
  "great",
  "green",
  "groovy",
  "gusty",
  "hallowed",
  "handsome",
  "handy",
  "happy",
  "harmless",
  "harmonious",
  "healthy",
  "heavenly",
  "helpful",
  "hilarious",
  "holistic",
  "hollow",
  "honorable",
  "humble",
  "hushed",
  "icy",
  "illustrious",
  "imaginary",
  "immense",
  "important",
  "impressive",
  "incredible",
  "industrious",
  "innovative",
  "inquisitive",
  "intelligent",
  "interesting",
  "intriguing",
  "inventive",
  "invincible",
  "iridescent",
  "jazzy",
  "jeweled",
  "jolly",
  "joyous",
  "keen",
  "kind",
  "kindhearted",
  "knowing",
  "languid",
  "lateral",
  "leafy",
  "legendary",
  "level",
  "light",
  "lively",
  "living",
  "lofty",
  "long",
  "lovely",
  "loving",
  "lucky",
  "luminous",
  "lunar",
  "lush",
  "luxurious",
  "lyrical",
  "magical",
  "magnetic",
  "magnificent",
  "majestic",
  "marvelous",
  "massive",
  "mellow",
  "melodic",
  "merciful",
  "mighty",
  "mild",
  "misty",
  "modern",
  "momentous",
  "mysterious",
  "natural",
  "neat",
  "neon",
  "nice",
  "nifty",
  "nimble",
  "noble",
  "nonstop",
  "northern",
  "nostalgic",
  "novel",
  "numerous",
  "observant",
  "oceanic",
  "open",
  "organic",
  "outstanding",
  "pacific",
  "painted",
  "panoramic",
  "parallel",
  "pastoral",
  "peaceful",
  "perfect",
  "persistent",
  "placid",
  "plaid",
  "playful",
  "pleasant",
  "plucky",
  "poised",
  "polar",
  "polished",
  "popular",
  "positive",
  "powerful",
  "precious",
  "pretty",
  "productive",
  "proud",
  "purple",
  "quaint",
  "quick",
  "quiet",
  "quilted",
  "quirky",
  "radiant",
  "rapid",
  "rare",
  "real",
  "regal",
  "reliable",
  "remarkable",
  "resilient",
  "resolute",
  "resonant",
  "rich",
  "righteous",
  "robust",
  "rocky",
  "romantic",
  "royal",
  "rustic",
  "safe",
  "sandy",
  "scented",
  "scientific",
  "secret",
  "serene",
  "sharp",
  "shimmering",
  "shiny",
  "silent",
  "silky",
  "simple",
  "sincere",
  "skilled",
  "sleek",
  "smart",
  "smooth",
  "snowy",
  "soft",
  "solar",
  "solid",
  "sophisticated",
  "sparkling",
  "special",
  "spectacular",
  "spicy",
  "splendid",
  "steadfast",
  "steady",
  "stellar",
  "stirring",
  "stormy",
  "strong",
  "stylish",
  "subtle",
  "successful",
  "sunny",
  "super",
  "superb",
  "supreme",
  "sweet",
  "swift",
  "talented",
  "tall",
  "tasteful",
  "teal",
  "tender",
  "terrific",
  "thankful",
  "thoughtful",
  "thrilling",
  "tidal",
  "tidy",
  "towering",
  "tranquil",
  "tremendous",
  "tropical",
  "trusted",
  "truthful",
  "ultra",
  "unique",
  "universal",
  "unusual",
  "upbeat",
  "useful",
  "valiant",
  "valuable",
  "vast",
  "verdant",
  "vibrant",
  "vigorous",
  "vintage",
  "vivid",
  "wakeful",
  "warm",
  "wealthy",
  "western",
  "whimsical",
  "wide",
  "wild",
  "wise",
  "witty",
  "wonderful",
  "wooden",
  "zealous",
  "zesty",
  "zippy",
];

const nouns = [
  "aardvark",
  "acorn",
  "afternoon",
  "airplane",
  "albatross",
  "almond",
  "alpaca",
  "alphabet",
  "amaryllis",
  "amethyst",
  "anchor",
  "anemone",
  "angelfish",
  "antelope",
  "apple",
  "apricot",
  "aquamarine",
  "aquarius",
  "arch",
  "arrow",
  "asteroid",
  "atlas",
  "aurora",
  "autumn",
  "avocado",
  "badger",
  "bagel",
  "balloon",
  "bamboo",
  "banana",
  "banjo",
  "barn",
  "basket",
  "beacon",
  "bear",
  "bee",
  "beetle",
  "bell",
  "bicycle",
  "birch",
  "bird",
  "bison",
  "blanket",
  "blizzard",
  "blossom",
  "bluebell",
  "boat",
  "bobcat",
  "bonfire",
  "book",
  "boots",
  "boulder",
  "breeze",
  "bridge",
  "brook",
  "bronze",
  "bubble",
  "bucket",
  "buffalo",
  "butterfly",
  "cactus",
  "cake",
  "camel",
  "camera",
  "canary",
  "candle",
  "canoe",
  "canyon",
  "cape",
  "cardinal",
  "caribou",
  "carnival",
  "carpet",
  "cascade",
  "castle",
  "cat",
  "cedar",
  "cellar",
  "cheetah",
  "cherry",
  "chestnut",
  "chickadee",
  "chief",
  "chimney",
  "chipmunk",
  "chocolate",
  "circle",
  "cliff",
  "clock",
  "cloud",
  "clover",
  "coast",
  "cobalt",
  "coconut",
  "coffee",
  "comet",
  "compass",
  "cookie",
  "copper",
  "coral",
  "cottage",
  "cotton",
  "cougar",
  "cove",
  "crane",
  "crater",
  "creek",
  "cricket",
  "crocus",
  "crosswind",
  "crown",
  "crystal",
  "cuckoo",
  "cupboard",
  "current",
  "daffodil",
  "dahlia",
  "dancer",
  "dandelion",
  "dawn",
  "deer",
  "denim",
  "desert",
  "diamond",
  "dolphin",
  "donkey",
  "dove",
  "dragon",
  "dragonfly",
  "dream",
  "drift",
  "drum",
  "duckling",
  "dune",
  "eagle",
  "earth",
  "echo",
  "eclipse",
  "eel",
  "eight",
  "elderberry",
  "elephant",
  "elk",
  "elm",
  "ember",
  "emerald",
  "engine",
  "equinox",
  "ermine",
  "evening",
  "evergreen",
  "falcon",
  "fawn",
  "feather",
  "fennel",
  "fern",
  "ferret",
  "finch",
  "firefly",
  "fjord",
  "flame",
  "flamingo",
  "flint",
  "flower",
  "flute",
  "fog",
  "forest",
  "fossil",
  "fountain",
  "fox",
  "frog",
  "frost",
  "future",
  "galaxy",
  "garden",
  "garnet",
  "gazelle",
  "gecko",
  "gem",
  "geyser",
  "ginger",
  "giraffe",
  "glacier",
  "glade",
  "glider",
  "globe",
  "gold",
  "goldfish",
  "goose",
  "gorilla",
  "granite",
  "grape",
  "grasshopper",
  "grove",
  "guitar",
  "gull",
  "harbor",
  "hare",
  "harmony",
  "harp",
  "hawk",
  "hawthorn",
  "hazel",
  "hearth",
  "hedgehog",
  "heron",
  "hibiscus",
  "hill",
  "hollyhock",
  "honey",
  "horizon",
  "hornet",
  "horse",
  "hummingbird",
  "hurricane",
  "hyacinth",
  "iceberg",
  "iguana",
  "impala",
  "indigo",
  "iris",
  "iron",
  "island",
  "ivy",
  "jackal",
  "jade",
  "jaguar",
  "jasmine",
  "jasper",
  "jay",
  "jellyfish",
  "juniper",
  "kangaroo",
  "kayak",
  "kestrel",
  "kettle",
  "kingfisher",
  "kite",
  "kitten",
  "kiwi",
  "koala",
  "lace",
  "lagoon",
  "lake",
  "lantern",
  "lapis",
  "larch",
  "lark",
  "laurel",
  "lavender",
  "leaf",
  "lemming",
  "lemon",
  "lemur",
  "leopard",
  "library",
  "lighthouse",
  "lilac",
  "lily",
  "lime",
  "linden",
  "linen",
  "lion",
  "lizard",
  "llama",
  "lobster",
  "lotus",
  "lynx",
  "macaw",
  "magic",
  "magnolia",
  "magpie",
  "mahogany",
  "mango",
  "mantis",
  "maple",
  "marble",
  "marigold",
  "marlin",
  "marmot",
  "marsh",
  "meadow",
  "melody",
  "melon",
  "meteor",
  "midnight",
  "mink",
  "mint",
  "mockingbird",
  "monarch",
  "moon",
  "moose",
  "morning",
  "moss",
  "moth",
  "mountain",
  "mushroom",
  "mustang",
  "myrtle",
  "narwhal",
  "navy",
  "nebula",
  "nectar",
  "newt",
  "nightingale",
  "nine",
  "noon",
  "nutmeg",
  "oak",
  "oasis",
  "obsidian",
  "ocean",
  "ocelot",
  "octopus",
  "olive",
  "onyx",
  "opal",
  "orange",
  "orca",
  "orchid",
  "oriole",
  "osprey",
  "otter",
  "owl",
  "oyster",
  "paddle",
  "palm",
  "panther",
  "paper",
  "parrot",
  "path",
  "peach",
  "peacock",
  "peak",
  "pear",
  "pebble",
  "pelican",
  "penguin",
  "peony",
  "pepper",
  "peridot",
  "petal",
  "pheasant",
  "phoenix",
  "piano",
  "pine",
  "planet",
  "plover",
  "plum",
  "pollen",
  "pond",
  "poplar",
  "poppy",
  "prairie",
  "prism",
  "puffin",
  "pulsar",
  "pumpkin",
  "python",
  "quail",
  "quartz",
  "rain",
  "rainbow",
  "raven",
  "reef",
  "reindeer",
  "riddle",
  "ridge",
  "river",
  "roadrunner",
  "robin",
  "rocket",
  "rose",
  "rosemary",
  "ruby",
  "sage",
  "sail",
  "salamander",
  "salmon",
  "sand",
  "sandpiper",
  "sapphire",
  "sardine",
  "satin",
  "saturn",
  "sea",
  "seahorse",
  "seal",
  "seed",
  "sequoia",
  "shadow",
  "shark",
  "sheep",
  "shell",
  "shore",
  "shrimp",
  "silk",
  "silver",
  "sky",
  "skylark",
  "sloth",
  "snail",
  "snow",
  "snowflake",
  "songbird",
  "sparrow",
  "spider",
  "spring",
  "sprout",
  "spruce",
  "squid",
  "squirrel",
  "square",
  "star",
  "starfish",
  "starling",
  "steam",
  "steel",
  "stone",
  "stork",
  "storm",
  "stream",
  "summit",
  "summer",
  "sun",
  "sunflower",
  "sunrise",
  "sunset",
  "sunshine",
  "surf",
  "swallow",
  "swan",
  "sycamore",
  "telescope",
  "temple",
  "thistle",
  "thorn",
  "thrush",
  "thunder",
  "tide",
  "tiger",
  "timber",
  "toad",
  "topaz",
  "toucan",
  "tower",
  "trail",
  "tree",
  "trout",
  "tulip",
  "tundra",
  "turquoise",
  "turtle",
  "twilight",
  "unicorn",
  "valley",
  "vanilla",
  "venus",
  "vessel",
  "vine",
  "violet",
  "viper",
  "volcano",
  "voyage",
  "vulture",
  "walnut",
  "walrus",
  "warbler",
  "water",
  "waterfall",
  "wave",
  "weasel",
  "whale",
  "wheat",
  "wildflower",
  "willow",
  "wind",
  "wing",
  "winter",
  "wolf",
  "wolverine",
  "woodpecker",
  "wren",
  "yarrow",
  "yew",
  "zebra",
  "zenith",
  "zephyr",
];

export function generateFriendlyName(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
  return `${adjective}_${noun}`;
}
